import React from 'react'
import styled from 'styled-components'
import RichText from '../../MwPage/components/RichText'
import LineIcon from '../../MwPage/icons'
import { Checks, ice2, iceLine, ink, muted, paper, Pill, Pills, price, sans, Small, ui } from '../../MwPage/styled'
import { fillTrial } from '../content/trial'
import { useFocus } from '../focus'
import { TrialButton } from './TrialCta'

// the prototype's .price: the offer card on a trial page
const Card = styled.aside`
  display: flex;
  flex-direction: column;
  gap: 18px;
  padding: clamp(22px, 3vw, 32px);
  border-radius: 28px;
  background: ${ice2};
  border: 2px solid ${iceLine};

  > p:first-child {
    margin: 0;
    font: 800 22px/1.2 ${sans};
    letter-spacing: -0.02em;
    color: ${ink};
  }
`

const Amount = styled.p`
  margin: 0;
  font: 800 clamp(2.5rem, 4vw, 3rem) / 1 ${ui};
  color: ${price};
`

// the prototype's .flow: today, the free week and day 8 side by side
const Flow = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 10px;

  > div {
    padding: 12px 14px;
    border-radius: 16px;
    background: ${paper};
    border: 1.5px solid ${iceLine};
  }

  small {
    display: block;
    margin-bottom: 4px;
    font: 700 11px/1.3 ${ui};
    letter-spacing: 0.1em;
    text-transform: uppercase;
    color: ${muted};
  }

  b {
    font: 800 18px/1.2 ${ui};
    color: ${ink};
  }

  @media (max-width: 420px) {
    grid-template-columns: 1fr;
  }
`

/** The trial's offer card: the price, when it is charged, the pills, the checks, the button and the terms. */
const TrialPriceCard = ({ offer }) => {
  const { trial, offer: copy } = useFocus()
  const { card } = trial
  const terms = fillTrial(card.terms, offer)

  return (
    <Card aria-label={copy.card.label}>
      <p>{card.title}</p>
      {offer.price && <Amount>{offer.price}</Amount>}
      <Flow>
        {card.flow.map(([when, amount]) => {
          const filled = fillTrial(amount, offer)
          return (
            <div key={when}>
              <small>{when}</small>
              <b>{filled || '…'}</b>
            </div>
          )
        })}
      </Flow>
      <Pills>
        {card.pills.map((pill, index) => (
          <Pill key={pill} $offer={index === 0}>
            {pill}
          </Pill>
        ))}
      </Pills>
      <Checks $column>
        {card.checks.map((item) => {
          const filled = fillTrial(item, offer)
          return (
            filled && (
              <li key={item}>
                <LineIcon name="check" />
                {filled}
              </li>
            )
          )
        })}
      </Checks>
      <TrialButton offer={offer} $block />
      {terms && (
        <Small>
          <RichText text={terms} />
        </Small>
      )}
    </Card>
  )
}

export default TrialPriceCard
